import { Outlet } from 'react-router-dom'
import Header from '../Shared-Component/Header/Header';
import Footer from '../Shared-Component/Footer/Footer';


const Alumini = () => {

    return (
        <div>
            <div className="header">
                <Header />
            </div>

            <div className="main-container">
                <div className="main-content">
                    <Outlet />
                </div>

                <div>
                    <Footer />
                </div>
            </div>
        </div>
    )
}

export default Alumini
